import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { SearchResultsPageHeader } from '../components/headers/SearchResultsPageHeader';
import { Paths } from '../constants/paths';
import { StorefrontFilterBar } from '../filters/components/StorefrontFilterBar';
import { KEY_PREFIX } from '../hooks/useSearchParams';
import { OtherCollections } from './components/OtherCollections';
import { ResultsGrid } from './components/ResultsGrid';
import { SearchResultsHeader } from './components/SearchResultsHeader';
import { SearchResultsPaginator } from './components/SearchResultsPaginator';
import { useCollectionQuery } from './hooks/useCollectionQuery';
import { parseSearchResultsPath } from './utils/parseSearchResultsPath';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SearchResultsPage() {
  useConvertPathParamsToSearchParams();
  const collectionResult = useCollectionQuery();
  if (collectionResult.loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1600"
    });
  }
  if (collectionResult.error) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  }
  return /*#__PURE__*/_jsx(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(SearchResultsPageHeader, {}),
    children: /*#__PURE__*/_jsxs(ErrorBoundary, {
      children: [/*#__PURE__*/_jsx(SearchResultsHeader, {}), /*#__PURE__*/_jsx(StorefrontFilterBar, {}), /*#__PURE__*/_jsx(ResultsGrid, {}), /*#__PURE__*/_jsx(SearchResultsPaginator, {}), collectionResult.data && /*#__PURE__*/_jsx(OtherCollections, {})]
    })
  });
}
function useConvertPathParamsToSearchParams() {
  const location = useLocation();
  const history = useHistory();
  const parsedPath = useMemo(() => parseSearchResultsPath(location.pathname), [location.pathname]);
  useEffect(() => {
    if (Object.keys(parsedPath).length === 0) return;
    const urlParams = new URLSearchParams();
    Object.entries(parsedPath).forEach(([key, value]) => {
      if (value) urlParams.set(`${KEY_PREFIX}${key}`, value.toString());
    });
    history.replace(`${Paths.SEARCH_RESULTS}?${urlParams.toString()}`);
  }, [parsedPath, history]);
}